import { render, staticRenderFns } from "./PortraitImage.vue?vue&type=template&id=9c4a3156&scoped=true"
import script from "./PortraitImage.vue?vue&type=script&lang=js"
export * from "./PortraitImage.vue?vue&type=script&lang=js"
import style0 from "./PortraitImage.vue?vue&type=style&index=0&id=9c4a3156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4a3156",
  null
  
)

export default component.exports